import { getLogin, getUsuario } from '@/utils/session';

export const PRODUCT_PIN_VISTAS = {
  pos: 'pos',
  mesas: 'mesas',
  manual: 'manual',
};

const PINS_MAX = 80;

export function productPinOwner() {
  return getLogin() || getUsuario() || 'anon';
}

function storageKey(vista, owner) {
  return `product_pins:${vista}:${owner || 'anon'}`;
}

export function leerProductPins(vista, owner = productPinOwner()) {
  try {
    const raw = localStorage.getItem(storageKey(vista, owner));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    const out = [];
    const seen = new Set();
    for (const id of parsed) {
      const s = String(id == null ? '' : id).trim();
      if (!s || seen.has(s)) continue;
      seen.add(s);
      out.push(s);
      if (out.length >= PINS_MAX) break;
    }
    return out;
  } catch {
    return [];
  }
}

export function guardarProductPins(vista, pins, owner = productPinOwner()) {
  const clean = leerProductPins(vista, owner);
  const next = Array.isArray(pins) ? pins.map(String) : clean;
  const out = [];
  const seen = new Set();
  for (const id of next) {
    const s = String(id || '').trim();
    if (!s || seen.has(s)) continue;
    seen.add(s);
    out.push(s);
    if (out.length >= PINS_MAX) break;
  }
  try {
    localStorage.setItem(storageKey(vista, owner), JSON.stringify(out));
  } catch {
    /* ignore */
  }
  return out;
}

export function toggleProductPin(vista, productoId, pins, owner = productPinOwner()) {
  const id = String(productoId == null ? '' : productoId);
  if (!id) return Array.isArray(pins) ? pins.slice() : leerProductPins(vista, owner);
  const actual = Array.isArray(pins) ? pins.map(String) : leerProductPins(vista, owner);
  const idx = actual.indexOf(id);
  const next = idx === -1 ? [id, ...actual.filter((x) => x !== id)] : actual.filter((x) => x !== id);
  return guardarProductPins(vista, next, owner);
}

export function productoEstaFijado(pins, productoId) {
  return (pins || []).includes(String(productoId == null ? '' : productoId));
}
